import $ from 'jquery';
import { throttle, getParams } from './utils';
import { random } from 'lodash';
import { api, arr } from './api';
import * as tips from './tips';
import configLang from './configLang';
import { generateScreenshot } from './screenshot';
import { fbShare, twShare, dcShare, nvShare, fbInit } from './share';
import { sdkOpenLink, isSdk } from './sdkCtrl';
import '../ico.png';
import '../img/pc/book-bg1.png';
import '../img/pc/book-bg2.png';
import '../img/pc/book-bg3.png';
import '../img/pc/book-hero1.png';
import '../img/pc/book-hero2.png';
import '../img/pc/book-hero3.png';
import '../img/pc/book-hero4.png';
import '../img/pc/book-hero5.png';
import '../img/pc/book-hero6.png';
import '../img/pc/book-hero7.png';
import '../img/pc/book-hero8.png';
import '../img/pc/book-hero9.png';
import '../img/pc/book-hero10.png';
import '../img/pc/book-hero11.png';
import '../img/pc/book-hero12.png';
import '../img/pc/book-hero13.png';
import '../img/pc/book-hero14.png';
import '../img/pc/book-hero15.png';
import '../img/pc/book-hero16.png';
import '../img/pc/book-weapon1.png';
import '../img/pc/book-weapon2.png';
import '../img/pc/book-weapon3.png';
import '../img/pc/book-weapon4.png';
import '../img/pc/book-weapon5.png';
import '../img/pc/book-weapon6.png';
import '../img/pc/book-weapon7.png';
import '../img/pc/book-weapon8.png';
import '../img/pc/book-weapon9.png';
import '../img/pc/book-weapon10.png';
import '../img/pc/book-weapon11.png';
import '../img/pc/book-weapon12.png';
import '../img/pc/book-weapon13.png';
import '../img/pc/book-weapon14.png';
import '../img/pc/book-weapon15.png';
import '../img/pc/book-weapon16.png';
import '../img/m/m-book-bg1.png';
import '../img/m/m-book-bg2.png';
import '../img/m/m-book-bg3.png';
import '../img/m/m-book-hero1.png';
import '../img/m/m-book-hero2.png';
import '../img/m/m-book-hero3.png';
import '../img/m/m-book-hero4.png';
import '../img/m/m-book-hero5.png';
import '../img/m/m-book-hero6.png';
import '../img/m/m-book-hero7.png';
import '../img/m/m-book-hero8.png';
import '../img/m/m-book-hero9.png';
import '../img/m/m-book-hero10.png';
import '../img/m/m-book-hero11.png';
import '../img/m/m-book-hero12.png';
import '../img/m/m-book-hero13.png';
import '../img/m/m-book-hero14.png';
import '../img/m/m-book-hero15.png';
import '../img/m/m-book-hero16.png';
import '../img/slider/en-slider-1.jpg';
import '../img/slider/en-slider-2.jpg';
import '../img/slider/en-slider-3.jpg';
import '../img/slider/en-slider-4.jpg';
import '../img/slider/en-slider-5.jpg';
import '../img/slider/en-slider-6.jpg';
import '../img/slider/tw-slider-1.jpg';
import '../img/slider/tw-slider-2.jpg';
import '../img/slider/tw-slider-3.jpg';
import '../img/slider/tw-slider-4.jpg';
import '../img/slider/tw-slider-5.jpg';
import '../img/slider/tw-slider-6.jpg';
import '../img/slider/ja-slider-1.jpg';
import '../img/slider/ja-slider-2.jpg';
import '../img/slider/ja-slider-3.jpg';
import '../img/slider/ja-slider-4.jpg';
import '../img/slider/ja-slider-5.jpg';
import '../img/slider/ja-slider-6.jpg';
import '../img/slider/kr-slider-1.jpg';
import '../img/slider/kr-slider-2.jpg';
import '../img/slider/kr-slider-3.jpg';
import '../img/slider/kr-slider-4.jpg';
import '../img/slider/kr-slider-5.jpg';
import '../img/slider/kr-slider-6.jpg';
import '../img/fb/tw-en.jpg'
import '../img/fb/tw-ja.jpg'
import '../img/fb/tw-kr.jpg'
import '../img/fb/tw-tw.jpg'

let qrcode = null;
let gameId = getParams('gameId') || 191;
const langAreaMap = {
  '香港': 'zh-tw',
  '澳门': 'zh-tw',
  '台湾': 'zh-tw',
  '日本': 'ja-jp',
  '韩国': 'ko-kr',
}
const gradeMap = {
  1: '1',
  2: '1',
  3: '1',
  4: '2',
  5: '2',
  6: '2',
  7: '2',
  8: '3',
  9: '3',
  10: '3',
  11: '3',
  12: '3',
}
const tagMap = {
  1: 'bookTag1',
  2: 'bookTag2',
  3: 'bookTag2',
  4: 'bookTag1',
  5: 'bookTag1',
  6: 'bookTag2',
  7: 'bookTag2',
  8: 'bookTag2',
  9: 'bookTag2',
  10: 'bookTag1',
  11: 'bookTag2',
  12: 'bookTag3',
}
export const state = {
  lang: 'en-us',
  isLogin: false,//是否登录
  account: '',
  roleInfo: {
    id: '',
    sid: '',
    rid: '',
    sname: '',
    rname: ''
  },
  isBind: false,//是否绑定
  serverList: [],
  isActivityEnd: false, // 活动是否已结束
  lotteryBookPage: ['0', '0', '0'], // 功法页码
  lotteryBookList: {}, // 解锁功法列表
  lotteryBookTimes: 0, // 功法抽奖次数
  groupCode: '', // 邀请码
  groupPeopleNum: 0, // 队伍人数
  groupMyPosition: 0, // 我在队伍位置
  lotteryAwardTimes: 0, // 道具抽奖次数
  taskList: {}, // 任务列表
  groupPeopleAvatarId: [], // 队伍头像id
  groupAwardStatus: 0, // 队伍奖励领取状态 0未达成 1未领取 2已领取
  tag: '', // 个人标签
  curBook: '0',
  curBg: '1',
  curHero: '1',
  curWeapon: '1',
};
const imgMap = {
  'en-us': 'en',
  'zh-tw': 'tw',
  'ja-jp': 'ja',
  'ko-kr': 'kr',
}
state.lang = getParams('language') || window.navigator.language || window.navigator.browserLanguage || window.navigator.systemLanguage;
state.lang = state.lang.toLowerCase();
state.lang = !state.lang ? 'en-us' : state.lang; // 如果是undefined的话就用默认

function setLang(langs, type = 'lang') {
  let realLang = '';
  let keyArr = [...Object.keys(tips.lang)];
  for (let i of keyArr) {
    if (i.includes(langs)) {
      realLang = i;
      break;
    }
  }
  realLang = realLang === '' ? 'en-us' : realLang;
  return tips[type][realLang] ? tips[type][realLang] : tips[type]['en-us'];
}

export function initLang(langs) {
  let langArr = langs.split("-");
  if (langArr[1]) {
    $("body").removeClass("us tw jp kr").addClass(langArr[1]);
  }
  for (let i = 1; i < 7; i++) {
    $('.j-img-' + i).attr('src', 'https://gevents.' + arr[1] + '.com/pnskfsquadron/img/'+imgMap[langs]+'-slider-' + i + '.jpg')
  }
  // 设置页面元素语言
  for (let i of configLang) {
    $(i.el).html(setLang(langs)[i.langKey]);
  }
}

const initMeta = (imgLang) => {
  addMeta('Keywords', getText('keyWords'));
  addMeta('description', getText('description'));
  addTwMeta('twitter:title', getText('ruleMainTitle'));
  addTwMeta('twitter:description', getText('description'));
  addTwMeta('twitter:image', 'https://gevents.pnsofficial.com/pnskfsquadron/img/tw-'+imgMap[imgLang]+'.jpg');
}

const addMeta = (metaname, content) => {
  const meta = document.createElement('meta');
  meta.content = content;
  meta.name = metaname;
  document.getElementsByTagName('head')[0].appendChild(meta);
};

const addTwMeta = (metaproperty, content) => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', metaproperty);
  meta.content = content;
  document.getElementsByTagName('head')[0].appendChild(meta);
};

export const getText = key => {
  return setLang(state.lang)[key];
}

const loginInit = async () => {
  const res = await api.checkLogin()
  if (res && res.result == 1) {
    state.account = res.data.LOGIN_ACCOUNT;
    state.isLogin = true;
    window.activityDataLayer.push({
      eventName: "login",
      aid: "pnskfsquadron",
      uid: res.data.UID,
      loginAccount: state.account,
      gameId: 191
    });
  }
}

export const basicInit = async () => {
  if (isSdk) {
    $('.j-download-game').hide();
  }
  $('.j-copyright-text').html('Copyright © www.' + arr[1] + '.com All Rights Reserved.');
  if (window.platform.isPhone()) {
    $(".j-book-bg").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/m-book-bg" + state.curBg + ".png");
    $(".j-book-hero").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/m-book-hero" + state.curHero + ".png");
  }
  const res = await api.getConfig();
  if (res && +res.result === 1) {
    if (state.isLogin) {
      $(".j-login-btn").hide();
      $(".j-logout-btn").show();
      state.lotteryBookList = res.data.lottery_book_list;
      state.lotteryBookTimes = +res.data.lottery_book_times;
      state.lotteryBookPage = res.data.lottery_book_page;
      state.groupCode = res.data.group_code;
      state.groupPeopleNum = +res.data.group_people_num;
      state.groupMyPosition = +res.data.group_my_position;
      state.lotteryAwardTimes = +res.data.lottery_award_times;
      state.taskList = res.data.task_list;
      state.groupPeopleAvatarId = res.data.group_people_avatar_id;
      state.groupAwardStatus = +res.data.group_award_status;
      state.tag = res.data.tag;
      initLock();
      if (state.groupPeopleNum === 0) {
        joinTeam();
      }
    }
    state.lang = langAreaMap[res.data.area] || 'en-us';
  } else {
    showTips(getText('errTip1'));
  }
  initLang(state.lang);
  initTeam();
  initChance();
};
const joinTeam = async () => {
  if(!getParams('inviteCode')){
    return;
  }
  const res = await api.joinGroup({ group_code: getParams('inviteCode') });
  if (res && +res.result === 1) {
    state.groupPeopleNum = +res.data.group_people_num;
    state.groupMyPosition = +res.data.group_my_position;
    state.groupPeopleAvatarId = res.data.group_people_avatar_id;
    state.groupCode = res.data.group_code;
    state.tag = res.data.tag;
    initTeam();
    updateCode();
  } else {
    if (res.code == -30002) {
      showTips(getText('errTip7'));
      return;
    }
    if (res.code == -30003) {
      showTips(getText('errTip8'));
      return;
    }
    if (res.code == -30004) {
      $('.j-popup-full').fadeIn();
      window.activityDataLayer.push({
        eventName: 'show_popup',
        eventType: '小队满员弹窗',
        aid: "pnskfsquadron",
        gameId: 191
      });
      return;
    }
    if (res.code == -70000) {
      showTips(getText('errTip8'));
      return;
    }
    if (res.code == -50000) {
      showTips(getText('errTip5'));
      return;
    }
    showTips(getText('errTip1'));
  }
}
const initLock = () => {
  if (state.lotteryBookList) {
    for (let i = 1; i < 13; i++) {
      if (state.lotteryBookList[i]) {
        $('.j-select-kungfu' + i).removeClass('lock');
      }
    }
  }
}
const initTeam = () => {
  if (+state.groupPeopleNum === 0) {
    $('.j-cipher-input').html(getParams('inviteCode'));
    $('.j-my-team-info').html(getText('myTeam') + getText('teamState1'));
    $('.j-team-state1').addClass('active').siblings().removeClass('active');
  } else if (+state.groupPeopleNum === 4) {
    for (let i = 1; i < state.groupPeopleAvatarId.length + 1; i++) {
      $('.j-team-member' + i).addClass('head-icon' + state.groupPeopleAvatarId[i - 1]);
    }
    $('.j-my-team-info').html(getText('myTeam') + getText('teamState3'));
    if(state.groupAwardStatus === 1){
      $('.j-get-share-award-btn').addClass('active').html(getText('getState2'));
    }else if(state.groupAwardStatus === 2){
      $('.j-get-share-award-btn').removeClass('active').html(getText('getState3'));
    }else{
      $('.j-get-share-award-btn').removeClass('active').html(getText('getState1'));
    }
    $('.j-get-share-award-btn').html(getText('getState' + (state.groupAwardStatus + 1)));
    $('.j-team-state3').addClass('active').siblings().removeClass('active');
  } else {
    for (let i = 1; i < state.groupPeopleAvatarId.length + 1; i++) {
      $('.j-team-member' + i).addClass('head-icon' + state.groupPeopleAvatarId[i - 1]);
    }
    if (state.groupPeopleNum > state.groupPeopleAvatarId.length) {
      for (let i = state.groupPeopleAvatarId.length + 1; i < state.groupPeopleNum + 1; i++) {
        $('.j-team-member' + i).addClass('head-icon' + random(1, 16));
      }
    }
    $('.j-my-team-info').html(getText('myTeam') + getText('teamState2').replace('${teamNum}', state.groupPeopleNum));
    $('.j-team-state2').addClass('active').siblings().removeClass('active');
    $('.j-quit-team' + state.groupMyPosition).addClass('active').siblings().removeClass('active');
  }
  $('.j-cipher-info').html(state.groupCode);
  $('.j-link-input').html("https://gevents.pnsofficial.com/pnskfsquadron/index.html?inviteCode=" + state.groupCode + "&tag=" + state.tag);
}
const initBook = () => {
  if (+state.curBook === 0) {
    $('.j-book-info-text1, .j-book-kungfu-name').hide();
    $('.j-book-kungfu-description').html(getText('noBook'));
    $('.j-book-kungfu-tag').hide();
    $('.j-book-grade').hide();
  } else {
    $('.j-book-info-text1, .j-book-kungfu-name').show().html('《' + getText('bookName' + state.curBook) + '》');
    $('.j-book-kungfu-description').html(getText('bookIntroduction' + state.curBook));
    $('.j-book-kungfu-tag').show().html(getText(tagMap[state.curBook]));
    $('.j-book-grade').show().removeClass('book-grade1 book-grade2 book-grade3').addClass('book-grade' + gradeMap[state.curBook]);
  }
  const [page1, page2, page3] = state.lotteryBookPage;
  let newText = getText('bookPageInfo')
    .replace('${page1}', page1)
    .replace('${page2}', page2)
    .replace('${page3}', page3);
  $('.j-book-info-text2').html(newText);
  $('.j-book-weapon-name').html(getText('weaponName' + state.curWeapon));
}
const initChance = () => {
  $('.j-surplus-book-chance').html(getText('surplusBookChance') + state.lotteryBookTimes);
  $('.j-surplus-skin-chance').html(getText('surplusSkinChance') + state.lotteryAwardTimes);
}
const initBag = async () => {
  const res = await api.listAward();
  if (res && +res.result === 1) {
    // 弹窗展示
    if (res.data && res.data.length) {
      let html = '';
      res.data.forEach(item => {
        html += `<li class="award-bag-item">
          <div class="award-bag-name">${getAwardName(item.award_block,item.award_id)}</div>
          <div class="award-bag-time">${item.award_time}</div>
          <div class="award-bag-text">${getText('getState3') + ': ' + item.award_server_id + '-' + item.award_role_name}</div>
          </li>`;
      });
      $('.j-award-bag-list').html(html);
    }
  } else {
    showTips(getText('errTip1'));
  }
}
const getAwardName = (award_block,award_id) => {
  if(award_block === 'lotteryAward') {
    return getText('awardName' + award_id);
  }else {
    return getText('awardName5');
  }
}
const initTask = () => {
  for (let i = 1; i < 7; i++) {
    if (state.taskList) {
      if (+state.taskList[i] === 1) {
        $('.j-get-chance-btn' + i).html(getText('getState2')).addClass('active');
      } else if (+state.taskList[i] === 2) {
        $('.j-get-chance-btn' + i).html(getText('getState4')).removeClass('active');
      } else if (+state.taskList[i] === 3) {
        $('.j-get-chance-btn' + i).html(getText('getState3')).removeClass('active');
      } else {
        $('.j-get-chance-btn' + i).html(getText('getState1')).removeClass('active');
      }
    } else {
      $('.j-get-chance-btn' + i).html(getText('getState1')).removeClass('active');
    }
  }
}
const initCode = () => {
  let qrcodeDiv = document.getElementById("qrcode");
  qrcode = new QRCode(qrcodeDiv, {
    text: "https://gevents.pnsofficial.com/pnskfsquadron/index.html?inviteCode=" + state.groupCode + "&tag=" + state.tag,
    width: 132,
    height: 132,
    colorDark: "#563b29",
    colorLight: "#ffffff",
    correctLevel: QRCode.CorrectLevel.L
  });
}
const updateCode = () => {
  qrcode.clear();
  qrcode.makeCode("https://gevents.pnsofficial.com/pnskfsquadron/index.html?inviteCode=" + state.groupCode + "&tag=" + state.tag);
}
export const showTips = tip => {
  $('.j-tips').html(tip);
  $('.j-popup').fadeOut();
  $('.j-popup-tip').fadeIn();
  window.activityDataLayer.push({
    eventName: 'show_popup',
    eventType: '提示弹窗',
    aid: "pnskfsquadron",
    gameId: 191
  });
};

export const checkLogin = () => {
  if (!state.isLogin) {
    // gotoLogin()
    $('.j-popup').fadeOut();
    $('.j-popup-login').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '请先登录弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
    return false
  }
  return true
}

export const checkBind = () => {
  if (!state.isBind) {
    bindInit();
    $('.j-popup').fadeOut();
    $('.j-popup-bind').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '绑定角色弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
    return false
  }
  return true
}

export const gotoLogin = () => {
  window.location.href = `https://gabres.${arr[1]}.com/platform/login.html?gameId=191&device=${window.platform.isPhone() ? 2 : 1
    }&forward=${encodeURIComponent(window.location.href)}`
}

const renderServerList = data => {
  let html = `<option value="0">${getText('pServer')}</option>`;
  if (data && data.recent_servers && data.recent_servers.length) {
    data.recent_servers.map(item => {
      html += `<option value="${item.sid}" data-id="${item.id}">${item.sname}</option>`;
    });
  }
  if (data && data.all_servers && data.all_servers.length) {
    data.all_servers.map(item => {
      html += `<option value="${item.sid}" ${item.id == state.roleInfo.id ? 'selected' : ''
        } data-id="${item.id}">${item.sname}</option>`;
    });
  }
  $('.j-select-server').html(html);
};
const renderRoleList = data => {
  let html = `<option value="0">${getText('pRole')}</option>`;
  if (data && data.length) {
    state.roleInfo.rid = data[0].roleID;
    state.roleInfo.rname = data[0].roleName;
    data.map(item => {
      html += `<option value="${item.roleID}" ${item.roleID == state.roleInfo.rid ? 'selected' : ''
        }>${item.roleName}</option>`;
    });
  }
  $('.j-select-role').html(html);
};
const resetRoleList = () => {
  renderRoleList();
  $('.j-select-role').val(0);
};
const bindInit = async () => {
  resetRoleList();
  let serverListRes = await api.getNewServer(gameId);
  +serverListRes.result > 0
    ? renderServerList(serverListRes.data)
    : renderServerList();
  if (!state.isBind && state.roleInfo.sid && state.roleInfo.rid) {
    let curServerId = $('.j-select-server').val();
    let roleListRes = await api.getCharacter(curServerId);
    +roleListRes.result > 0
      ? renderRoleList(roleListRes.data)
      : renderRoleList();
  }
};
const initEvent = () => {
  $('.j-go-btn').on('click', function () {
    const websiteLinkMap = {
      'zh-tw': 'https://www.blancozone.com/blancozone/ztmslgtw/?store=1&cid=activity&scid=pnskfsquadron',
      'ja-jp': 'https://jp.37games.com/ztmslg/index.html?store=1&cid=activity&scid=pnskfsquadron',
      'ko-kr': 'https://www.blancozone.com/blancozone/ztmslgkr/?store=1&cid=activity&scid=pnskfsquadron',
      'en-us': 'https://www.pnsofficial.com/pnsofficial/ztmslg/?store=1&cid=activity&scid=pnskfsquadron',
    }
    let websiteLink = websiteLinkMap[state.lang] ? websiteLinkMap[state.lang] : 'https://www.pnsofficial.com/pnsofficial/ztmslg/?store=1&cid=activity&scid=pnskfsquadron';
    if (isSdk) {
      sdkOpenLink(websiteLink);
    } else {
      window.open(websiteLink);
    }
  });
  $('.j-download-game').on('click', function () {
    const downloadLinkMap = {
      'zh-tw': 'https://pnstw.onelink.me/YhZR?af_xp=custom&pid=casualgame&c=casualgame',
      'ja-jp': 'https://pns.onelink.me/1Jz4?af_xp=custom&pid=casualgame&c=casualgame',
      'ko-kr': 'https://poz.onelink.me/F7wm?af_xp=custom&pid=casualgame',
      'en-us': 'https://pns.onelink.me/1Jz4?af_xp=custom&pid=casualgame&c=casualgame',
    }
    let downloadLink = downloadLinkMap[state.lang] ? downloadLinkMap[state.lang] : 'https://pns.onelink.me/1Jz4?af_xp=custom&pid=casualgame&c=casualgame';
    if (isSdk) {
      sdkOpenLink(downloadLink);
    } else {
      window.open(downloadLink);
    }
  });
  $('.j-login-btn').on('click', function () {
    gotoLogin();
  });
  $('.j-logout-btn').on('click', function () {
    api.logout().then(() => {
      window.location.reload();
    });
  });
  $('.j-activity-rule').on('click', function () {
    $('.j-popup-rule').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '活动规则弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('body').on('click', '.j-collect', ({ currentTarget }) => {
    let eventType = currentTarget.dataset.eventtype;
    let eventName = currentTarget.dataset.eventname;
    let eventReason = currentTarget.dataset.eventreason;
    window.activityDataLayer.push({
      eventName: eventName || 'click_button',
      eventType: eventType,
      eventReason: eventReason || '',
      aid: "pnskfsquadron",
      gameId: 191
    })
  });
  $('.j-service-link').on('click', function () {
    window.open('https://gpassport.' + arr[1] + '.com/center/ServicePrivacy/service');
  });
  $('.j-privicy-link').on('click', function () {
    window.open('https://gpassport.' + arr[1] + '.com/center/ServicePrivacy/privacy');
  });
  $('.j-popup-close').on('click', function () {
    $('.j-popup').fadeOut(300);
  });
  $('.j-select-btn').on('click', function () {
    let typeNameMap = {
      '1': '功法',
      '2': '背景',
      '3': '英雄',
      '4': '武器',
    };
    if (!checkLogin()) {
      return;
    }
    let tabId = $(this).attr('data-tab');
    $(this).addClass('active').siblings().removeClass('active');
    $('.j-select-block' + tabId).addClass('active').siblings().removeClass('active');
    window.activityDataLayer.push({
      eventName: 'select_DIY',
      eventType: typeNameMap[tabId],
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('.j-select-server').on('change', async function () {
    let serverId = $(this).val();
    let selectedOption = $('.j-select-server option:selected');
    state.roleInfo.id = selectedOption.attr('data-id');
    resetRoleList();
    if (serverId == 0) return;
    let roleListRes = await api.getCharacter(serverId);
    +roleListRes.result > 0
      ? renderRoleList(roleListRes.data)
      : renderRoleList();
  });
  $('.j-popup-bind-confirm').on('click', async function () {
    let id = state.roleInfo.id;
    let sid = $('.j-select-server').val();
    let rid = $('.j-select-role').val();
    let sname = $('.j-select-server').find('option:selected').text();
    let rname = $('.j-select-role').find('option:selected').text();
    if (!sid || sid == 0) {
      alert(getText('pServer'));
      return;
    }
    if (!rid || rid == 0) {
      alert(getText('pRole'));
      return;
    }
    let charInfo = { id, sid, rid, sname, rname };
    state.roleInfo = Object.assign(charInfo, {});
    state.isBind = true;
    $('.j-book-role-name').html(state.roleInfo.rname).addClass('active');
    $('.j-book-server-name').html(state.roleInfo.sname).addClass('active');
    $('.j-popup-bind').fadeOut();
  });
  $('.j-create-team').on('click', async () => {
    if (!checkLogin()) {
      return;
    }
    const res = await api.createGroup();
    if (res && +res.result === 1) {
      state.groupPeopleNum = +res.data.group_people_num;
      state.groupMyPosition = +res.data.group_my_position;
      state.groupPeopleAvatarId = res.data.group_people_avatar_id;
      state.groupCode = res.data.group_code;
      state.tag = res.data.tag;
      initTeam();
      updateCode();
    } else {
      if (res.code == -1004) {
        $('.j-popup-login').fadeIn();
        window.activityDataLayer.push({
          eventName: 'show_popup',
          eventType: '请先登录弹窗',
          aid: "pnskfsquadron",
          gameId: 191
        });
        return;
      }
      showTips(getText('errTip1'));
    }
  });
  $('.j-join-team').on('click', async () => {
    if (!checkLogin()) {
      return;
    }
    let groupCode = $('.j-cipher-input').text().trim();
    const res = await api.joinGroup({ group_code: groupCode });
    if (res && +res.result === 1) {
      state.groupPeopleNum = +res.data.group_people_num;
      state.groupMyPosition = +res.data.group_my_position;
      state.groupPeopleAvatarId = res.data.group_people_avatar_id;
      state.groupCode = res.data.group_code;
      state.tag = res.data.tag;
      initTeam();
    } else {
      if (res.code == -30002) {
        showTips(getText('errTip7'));
        return;
      }
      if (res.code == -30003) {
        showTips(getText('errTip8'));
        return;
      }
      if (res.code == -30004) {
        $('.j-popup-full').fadeIn();
        window.activityDataLayer.push({
          eventName: 'show_popup',
          eventType: '小队满员弹窗',
          aid: "pnskfsquadron",
          gameId: 191
        });
        return;
      }
      showTips(getText('errTip1'));
    }
  });
  $('.j-quit-btn').on('click', async () => {
    $('.j-popup').fadeOut();
    if (!checkLogin()) {
      return;
    }
    const res = await api.cancelGroup();
    if (res && +res.result === 1) {
      state.groupPeopleNum = 0;
      state.groupCode = '';
      state.tag = '';
      initTeam();
      updateCode();
    } else {
      showTips(getText('errTip1'));
    }
  });
  $('.j-get-share-award-btn').on('click', async () => {
    if (!checkLogin()) {
      return;
    }
    if (!checkBind()) {
      return;
    }
    const res = await api.groupAward({ server_id: state.roleInfo.id, role_id: state.roleInfo.rid, role_name: state.roleInfo.rname });
    if (res && +res.result === 1) {
      // 成功提示
      showTips(getText('errTip3'));
      // 按钮更新
      $('.j-get-share-award-btn').removeClass('active').html(getText('getState3'));
    } else {
      if (res.code == -50000) {
        showTips(getText('errTip5'));
        return;
      }
      if (res.code == -50001) {
        showTips(getText('errTip10'));
        return;
      }
      if (res.code == -50002) {
        showTips(getText('errTip11'));
        return;
      }
      if (res.code == -50003) {
        showTips(getText('errTip4'));
        return;
      }
      showTips(getText('errTip1'));
    }
  });
  $('.j-lottery-book-btn').on('click', async () => {
    if (!state.isLogin) {
      state.curBook = random(1, 12);
      initBook();
      return;
    }
    const res = await api.lotteryBook();
    if (res && +res.result === 1) {
      let id = res.data.id;
      // 弹窗展示
      $('.j-book-name').html(getText('bookName' + id));
      $('.j-book-quality').html(getText('bookGrade' + gradeMap[id]));
      $('.j-book-introduction').html(getText('bookIntroduction' + id));
      $('.j-popup-get-book').fadeIn();
      window.activityDataLayer.push({
        eventName: 'show_popup',
        eventType: '获得功法弹窗',
        aid: "pnskfsquadron",
        gameId: 191
      });
      // 解锁 更新解锁列表
      state.lotteryBookList[id] = 1;
      $('.j-select-kungfu' + id).removeClass('lock');
      // 更新剩余次数
      state.lotteryBookTimes = res.data.lottery_book_times;
      $('.j-surplus-book-chance').html(getText('surplusBookChance') + state.lotteryBookTimes);
    } else {
      if (res.code == -10000) {
        showTips(getText('errTip6'));
        return;
      }
      showTips(getText('errTip1'));
    }
  });
  $('.j-lottery-skin-btn').on('click', throttle(async () => {
    if (!checkLogin()) {
      return;
    }
    if (!checkBind()) {
      return;
    }
    $(".j-award-icon").addClass("shake");
    const res = await api.lotteryAward({ server_id: state.roleInfo.id, role_id: state.roleInfo.rid, role_name: state.roleInfo.rname });
    if (res && +res.result === 1) {
      let id = res.data.id;
      // 弹窗展示
      $('.j-award-icon').removeClass('award-icon1 award-icon2 award-icon3 award-icon4 award-icon5 award-icon6 award-icon7 award-icon8 award-icon9 award-icon10 award-icon11').addClass('award-icon' + id);
      $('.j-award-name').html(getText('awardName' + id));
      setTimeout(() => {
        $('.j-popup-get-award').fadeIn();
        $(".j-award-icon").removeClass("shake");
      }, 500);
      window.activityDataLayer.push({
        eventName: 'show_popup',
        eventType: '获得奖励弹窗',
        aid: "pnskfsquadron",
        gameId: 191
      });
      // 更新剩余次数
      state.lotteryAwardTimes = res.data.lottery_award_times;
      $('.j-surplus-skin-chance').html(getText('surplusSkinChance') + state.lotteryAwardTimes);
    } else {
      setTimeout(() => {
        $(".j-award-icon").removeClass("shake");
      }, 500);
      if (res.code == -10000) {
        showTips(getText('errTip6'));
        return;
      }
      if (res.code == -50000) {
        showTips(getText('errTip5'));
        return;
      }
      showTips(getText('errTip1'));
    }
  }, 1000));
  $('.j-get-more-btn,.j-get-book-btn').on('click', () => {
    if (!checkLogin()) {
      return;
    }
    basicInit();
    // 初始化按钮
    initTask();
    $('.j-popup-get-chance').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '获取更多弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('.j-scroll').on('click', function () {
    $('.j-popup').fadeOut(300);
    let scrollEleSelector = $(this).attr('data-scroll');
    let topNum = $(this).attr('data-top');
    $('html, body').animate(
      {
        scrollTop: $(scrollEleSelector).offset().top + parseInt(topNum),
      },
      500
    );
    $(this).addClass('active').siblings().removeClass('active');
  });
  $('.j-share-invite, .j-continue-share').on('click', () => {
    $('.j-invite-link').html("https://gevents.pnsofficial.com/pnskfsquadron/index.html?inviteCode=" + state.groupCode + "&tag=" + state.tag);
    $('.j-popup-invite').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '邀请弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('.j-see-award-pool').on('click', () => {
    $('.j-popup-award-show').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '查看奖池弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('.j-award-bag').on('click', async () => {
    if (!checkLogin()) {
      return;
    }
    await initBag();
    $('.j-popup-award-bag').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '奖励背包弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  $('.j-quit-team').on('click', () => {
    $('.j-popup-quit').fadeIn();
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '退出小队弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
  });
  for (let i = 1; i < 7; i++) {
    $('.j-get-chance-btn' + i).on('click', async () => {
      if (!checkBind()) {
        return;
      }
      const res = await api.getAwardTimes({ id: i, server_id: state.roleInfo.id, role_id: state.roleInfo.rid, role_name: state.roleInfo.rname });
      if (res && +res.result === 1) {
        // 按钮更新 抽奖次数更新
        await basicInit();
        initTask();
      } else {
        if (res.code == -50000) {
          showTips(getText('errTip5'));
          return;
        }
        if (res.code == -50001) {
          showTips(getText('errTip10'));
          return;
        }
        if (res.code == -50002) {
          showTips(getText('errTip11'));
          return;
        }
        if (res.code == -50003) {
          showTips(getText('errTip4'));
          return;
        }
        showTips(getText('errTip1'));
      }
    });
  }
  $('.j-copy-cipher').on('click', function () {
    let clipboard = new ClipboardJS('.j-copy-cipher', {
      text: function () {
        return $('#cipher-info').text();
      }
    });
  });
  $('.j-copy-link').on('click', function () {
    let clipboard = new ClipboardJS('.j-copy-link', {
      text: function () {
        return $('#link-input').text();
      }
    });
  });
  $('.j-copy-invite-link').on('click', function () {
    let clipboard = new ClipboardJS('.j-copy-invite-link', {
      text: function () {
        return $('#invite-link').text();
      }
    });
    $('.j-copy-tip').show();
  });
  $('.j-copy-share-invite-link').on('click', function () {
    let clipboard = new ClipboardJS('.j-copy-share-invite-link', {
      text: function () {
        return $('#share-invite-link').text();
      }
    });
    $('.j-share-copy-tip').show();
  });
  $('.j-fb-share-btn').on('click', function () {
    fbShare();
  });
  $('.j-dc-share-btn').on('click', function () {
    dcShare();
  });
  $('.j-tw-share-btn').on('click', function () {
    twShare();
  });
  $('.j-nv-share-btn').on('click', function () {
    nvShare();
  });
  $('.j-fb-btn').on('click', function () {
    const fbLinkMap = {
      'en-us': 'https://www.facebook.com/PnS.37Games',
      'zh-tw': 'https://www.facebook.com/PnS.TW',
      'ko-kr': 'https://www.facebook.com/puzzleofZ.KR/',
    };
    let fbLink = fbLinkMap[state.lang] || 'https://www.facebook.com/PnS.37Games';
    if (isSdk) {
      sdkOpenLink(fbLink);
    } else {
      window.open(fbLink);
    }
  });
  $('.j-tw-btn').on('click', function () {
    if (isSdk) {
      sdkOpenLink('https://twitter.com/37games_pnsjp');
    } else {
      window.open('https://twitter.com/37games_pnsjp');
    }
  });
  $('.j-dc-btn').on('click', function () {
    if (isSdk) {
      sdkOpenLink('https://discord.gg/puzzlesandsurvival');
    } else {
      window.open('https://discord.gg/puzzlesandsurvival');
    }
  });
  $('.j-nv-btn').on('click', function () {
    if (isSdk) {
      sdkOpenLink('https://game.naver.com/lounge/puzzle_of_Z/home');
    } else {
      window.open('https://game.naver.com/lounge/puzzle_of_Z/home');
    }
  });
  $('.j-copyright').on('click', () => {
    $('.j-footer').toggleClass('active');
  });
  $('.j-save-share-btn').on('click', async function () {
    if (!checkLogin()) {
      return;
    }
    if (+state.curBook === 0) {
      showTips(getText('noBook'));
      return;
    }
    if (window.platform.isPhone()) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    setTimeout(() => {
      generateScreenshot();
    }, 300);
    window.activityDataLayer.push({
      eventName: 'create_pnskfsquadron',
      eventValue: state.lotteryBookPage[0] + '部' + state.lotteryBookPage[1] + '章' + state.lotteryBookPage[2] + '节',
      aid: "pnskfsquadron",
      gameId: 191
    });
    state.groupPeopleNum === 0 && $('.j-share-tip-block').show();
    $('.j-share-invite-link').html(getText('copyShareText').replace('${cipher}', state.groupCode) + "https://gevents.pnsofficial.com/pnskfsquadron/index.html?inviteCode=" + state.groupCode + "&tag=" + state.tag);
    $('.j-popup-share').fadeIn(600);
    window.activityDataLayer.push({
      eventName: 'show_popup',
      eventType: '分享弹窗',
      aid: "pnskfsquadron",
      gameId: 191
    });
    if (getParams('inviteCode') && getParams('tag')) {
      const res = await api.completeInvite({ group_code: getParams('inviteCode'), tag: getParams('tag') });
      if (res && +res.result === 1) {
        // 成功提示
        // 按钮更新 抽奖次数更新
        await basicInit();
      } else {
        if (res.code == -50000) {
          showTips(getText('errTip5'));
          return;
        }
        if (res.code == -30002) {
          showTips(getText('errTip7'));
          return;
        }
        if (res.code == -30003) {
          showTips(getText('errTip8'));
          return;
        }
        if (res.code == -70000) {
          showTips(getText('errTip8'));
          return;
        }
        showTips(getText('errTip1'));
      }
    }
  });
  $('.j-select-kungfu').on('click', function () {
    let id = $(this).attr('data-kungfu');
    if (state.lotteryBookList[id] === 1) {
      state.curBook = id;
      $(this).addClass('active').siblings().removeClass('active');
      initBook();
    }
  });
  $('.j-select-bg').on('click', function () {
    let id = $(this).attr('data-bg');
    state.curBg = id;
    $(this).addClass('active').siblings().removeClass('active');
    if (window.platform.isPhone()) {
      $(".j-book-bg").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/m-book-bg" + id + ".png");
    } else {
      $(".j-book-bg").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/book-bg" + id + ".png");
    }
  });
  $('.j-select-hero').on('click', function () {
    let id = $(this).attr('data-hero');
    state.curHero = id;
    $(this).addClass('active').siblings().removeClass('active');
    if (window.platform.isPhone()) {
      $(".j-book-hero").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/m-book-hero" + id + ".png");
    } else {
      $(".j-book-hero").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/book-hero" + id + ".png");
    }
  });
  $('.j-select-weapon').on('click', function () {
    let id = $(this).attr('data-weapon');
    state.curWeapon = id;
    $(this).addClass('active').siblings().removeClass('active');
    $('.j-book-weapon-name').html(getText('weaponName' + id));
    $(".j-book-weapon").attr("src", "https://gevents." + arr[1] + ".com/pnskfsquadron/img/book-weapon" + id + ".png");
  });
};

export const init = async function () {
  window.activityDataLayer.push({
    eventName: "view_page",
    aid: 'pnskfsquadron',
    gameId: 191
  });
  dataLayer.push({
    event: 'entrance',
    scid: getParams('scid'),
    cid: getParams('cid')
  });
  initLang(state.lang);
  await loginInit();
  await basicInit();
  initMeta(state.lang);
  fbInit(state.lang);
  initBook();
  initCode();
  initEvent();
};
